import { useContext, useEffect, useState } from "react";
import { ProgressContext } from "../../components/Context/progressContext";
import { RequestNextApi } from "../../api/Request";
import { ShowNotification } from "../../utils/notification/snackbarUtils";
import { GlobalsContext } from "../../components/Context/globalsContext";
import Error404 from "../404";
import LargeFirmHome from "../industry-leader/large-firms/components/home";
import {PAGES_SLUG} from '../../utils/static-pages/model';

export default function WomensCommunityGroup() {

    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    const [pageExist,setPageExist] = useState(true);
    const { update: updateGlobals, state: globalsContext } = useContext(GlobalsContext);

    const slug = PAGES_SLUG.WOMENS_COMMUNITY_GROUP;

    useEffect(()=>{
        const initPage = async (slug) => {
            updateProgress({ isLoading: true });
            await fetchFirms(slug);
        };
            initPage(slug);
    },[slug]);

    const fetchFirms = async(slug)=>{
        try{
            const res = await RequestNextApi.post('/large-firms',
              {
                  slug: slug,
                  password:""
              }
            );
            if (res.data) {
                console.log(res.data.success);
                updateGlobals({ globals: res.data,
                    isLogin:true });
                updateProgress({ isLoading: false });
            } else {
                ShowNotification.error(res.data.message);
            }
        }catch(error){
            console.log('fetch firm error '+error);
            updateProgress({ isLoading: false });
        }
    }
    return (
      <>
            <LargeFirmHome></LargeFirmHome>
      </>
    );
}

WomensCommunityGroup.isPublic = true;
WomensCommunityGroup.getLayout = page => <>{page}</>;
